import React from "react";

function RadioInput({
  name,
  label,
  options,
  styled,
  disabled,
  onChange,
  onBlur,
  error,
  value,
  customFlexCol,
  className,
  withoutText,
  customClassName,
}) {
  return (
    <div className="space-y-2">
      {label && <p className="text-sm font-bold sm:text-base">{label}</p>}
      <div
        className={`${
          styled ? "space-y-4" : `flex ${className ? className : "space-x-6"}`
        } `}
      >
        {options?.map((option, i) =>
          styled ? (
            <label
              key={i}
              className="flex justify-between p-4 text-sm border border-black rounded-md bg-app-light-grey sm:text-base"
              htmlFor={option.name}
            >
              <div>
                <p className="font-bold">{option.text}</p>
                <p className="">{option.description}</p>
              </div>
              <input
                type="radio"
                id={option.name}
                name={name}
                disabled={disabled}
                onChange={onChange}
                onBlur={onBlur}
                value={option?.id}
                checked={option?.id === value}
              />
            </label>
          ) : (
            <div
              key={i}
              className={
                customClassName
                  ? customClassName
                  : `space-x-2 text-sm sm:text-base`
              }
            >
              {customFlexCol ? (
                <div
                  className={
                    customFlexCol
                      ? "flex flex-col items-center justify-center gap-4"
                      : ""
                  }
                >
                  {withoutText ? null : (
                    <label htmlFor={option.name}>{option.text}</label>
                  )}
                  <input
                    type="radio"
                    id={option.name}
                    name={name}
                    disabled={disabled}
                    onChange={onChange}
                    onBlur={onBlur}
                    value={option?.id}
                    checked={option?.id === value}
                  />
                </div>
              ) : (
                <>
                  <input
                    type="radio"
                    id={option.name}
                    name={name}
                    disabled={disabled}
                    onChange={onChange}
                    onBlur={onBlur}
                    value={option?.id}
                    checked={option?.id === value}
                  />
                  <label htmlFor={option.name}>{option.text}</label>
                </>
              )}
            </div>
          )
        )}
      </div>
      {error && <p className="text-xs text-red-500">{error}</p>}
    </div>
  );
}

export default RadioInput;
